import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-005afb68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "現在のステータス", -1))
const _hoisted_3 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32 tex-center" }, "未入力", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, [
  /*#__PURE__*/_createTextVNode("\n            アカウント認証が完了していません"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n            各情報を入力し、アカウント認証してください\n          ")
], -1))
const _hoisted_6 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32 tex-center" }, "認証済み", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n            アカウントは認証されています\n          ", -1))
const _hoisted_9 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32 tex-center" }, "審査中", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, [
  /*#__PURE__*/_createTextVNode("\n            アカウント審査中です"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n            審査完了までしばらくお待ちください"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n            審査は約1時間以内に完了します\n          ")
], -1))
const _hoisted_12 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32 tex-center" }, "未認証", -1))
const _hoisted_14 = { class: "text-mild text-size-14 text-pre-wrap" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n          各項目を全て入力し、アカウント認証を申請してください\n        ", -1))
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-red px-3 py-2 mt-3 round-18"
}
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-size-14 ml-2" }, "\n              アカウント認証申請が完了していません\n            ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_BgWaveCard = _resolveComponent("BgWaveCard")!
  const _component_RegistrationInformationCard = _resolveComponent("RegistrationInformationCard")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { ref: "header" }, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      アカウント管理\n    ")
      ], undefined, true),
      _: 1
    }, 512),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BgWaveCard, { class: "mt-3 mb-4" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(),
          (!_ctx.user.hasRegisteredProfile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_FeatherIcon, {
                    icon: "alert-circle",
                    size: "3x",
                    class: "text-red pr-2"
                  }),
                  _createTextVNode(),
                  _hoisted_4
                ]),
                _createTextVNode(),
                _hoisted_5
              ], 64))
            : (_ctx.user.verifiedStatus === 'verified')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FeatherIcon, {
                      icon: "check-circle",
                      size: "3x",
                      class: "text-green pr-2"
                    }),
                    _createTextVNode(),
                    _hoisted_7
                  ]),
                  _createTextVNode(),
                  _hoisted_8
                ], 64))
              : (_ctx.isUnderExamination)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_FeatherIcon, {
                        icon: "circle",
                        size: "3x",
                        class: "text-yellow pr-2"
                      }),
                      _createTextVNode(),
                      _hoisted_10
                    ]),
                    _createTextVNode(),
                    _hoisted_11
                  ], 64))
                : (_ctx.user.verifiedStatus === 'rejected')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FeatherIcon, {
                          icon: "alert-circle",
                          size: "3x",
                          class: "text-red pr-2"
                        }),
                        _createTextVNode(),
                        _hoisted_13
                      ]),
                      _createTextVNode(),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.user.rejectionReason.details), 1)
                    ], 64))
                  : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createElementVNode("div", null, [
        _hoisted_15,
        _createTextVNode(),
        (_ctx.isAlreadyChanged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FeatherIcon, {
                  icon: "alert-circle",
                  size: "1x",
                  class: "text-white"
                }),
                _createTextVNode(),
                _hoisted_18
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_RegistrationInformationCard, {
          title: "基本情報",
          to: { name: 'MypagePersonalInfo' },
          isUnderExamination: _ctx.isUnderExamination,
          isVerified: _ctx.isVerified,
          isRejected: _ctx.isPersonalInfoRejected,
          hasRegistered: _ctx.hasRegisteredPersonalInfo,
          isModified: 
            _ctx.modifiedStatuses ? _ctx.modifiedStatuses.isPersonalInfoModified : false
          ,
          class: "mt-3"
        }, null, 8, ["isUnderExamination", "isVerified", "isRejected", "hasRegistered", "isModified"]),
        _createTextVNode(),
        _createVNode(_component_RegistrationInformationCard, {
          title: "プロフィール写真",
          to: { name: 'MypageEditAvatar' },
          isUnderExamination: _ctx.isUnderExamination,
          isVerified: _ctx.isVerified,
          isRejected: _ctx.isAvatarRejected,
          hasRegistered: _ctx.hasRegisteredAvatar,
          isModified: 
            _ctx.modifiedStatuses ? _ctx.modifiedStatuses.isAvatarModified : false
          ,
          class: "mt-2"
        }, null, 8, ["isUnderExamination", "isVerified", "isRejected", "hasRegistered", "isModified"]),
        _createTextVNode(),
        _createVNode(_component_RegistrationInformationCard, {
          title: "身分証",
          to: { name: 'MypageEditId' },
          isUnderExamination: _ctx.isUnderExamination,
          isVerified: _ctx.isVerified,
          isRejected: _ctx.isIdRejected,
          hasRegistered: _ctx.hasRegisteredIdentifier,
          isModified: 
            _ctx.modifiedStatuses ? _ctx.modifiedStatuses.isIdentifierModified : false
          ,
          class: "mt-2"
        }, null, 8, ["isUnderExamination", "isVerified", "isRejected", "hasRegistered", "isModified"])
      ]),
      _createTextVNode(),
      (!_ctx.user.hasRegisteredProfile)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            block: "",
            class: "my-4",
            onClick: _ctx.onClickInitialProfileRegister
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        アカウント認証を申請する\n      ")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            block: "",
            class: "my-4",
            onClick: _ctx.onSubmit,
            disabled: _ctx.isUnderExamination
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
            ], undefined, true),
            _: 1
          }, 8, ["onClick", "disabled"]))
    ])
  ]))
}